<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useKeyboardEvents } from 'dashboard/composables/useKeyboardEvents';
import lumeratecConstants from 'dashboard/constants/globals';

const props = defineProps({
  items: {
    type: Array,
    default: () => [],
  },
  activeTab: {
    type: String,
    default: lumeratecConstants.ASSIGNEE_TYPE.ME,
  },
});

const emit = defineEmits(['chatTabChange']);
const { t } = useI18n();

const activeTabIndex = computed(() => {
  return props.items.findIndex(item => item.key === props.activeTab);
});

const onTabChange = selectedTabIndex => {
  if (selectedTabIndex >= 0 && selectedTabIndex < props.items.length) {
    const selectedItem = props.items[selectedTabIndex];
    if (selectedItem.key !== props.activeTab) {
      emit('chatTabChange', selectedItem.key);
      window.dispatchEvent(
        new CustomEvent('a11y-announce', {
          detail: {
            message: t('CONVERSATION.ACCESSIBILITY.QUEUE_SELECTED', {
              name: selectedItem.name,
            }),
          },
        })
      );
    }
  }
};

const keyboardEvents = {
  ...Object.fromEntries(
    Array.from({ length: 4 }, (_, index) => [
      `Alt+Shift+Digit${index + 1}`,
      {
        action: event => {
          event.preventDefault();
          onTabChange(index);
        },
        allowOnFocusedInput: false,
      },
    ])
  ),
};

useKeyboardEvents(keyboardEvents);
</script>

<template>
  <woot-tabs
    :index="activeTabIndex"
    class="w-full px-3 -mt-1 py-0 [&_ul]:p-0 h-10"
    @change="onTabChange"
  >
    <woot-tabs-item
      v-for="(item, index) in items"
      :key="item.key"
      class="text-sm [&_a]:font-medium"
      :index="index"
      :name="item.name"
      :count="item.count"
      is-compact
    />
  </woot-tabs>
</template>
